// extracted by mini-css-extract-plugin
module.exports = {"resume":"CreateResume-module--resume--2h60X","backdrop":"CreateResume-module--backdrop--1W9wn","page":"CreateResume-module--page--21vUh","meta":"CreateResume-module--meta--2ISTj"};